<template>
  <sweet-modal
    ref="modal"
    class="vld-parent"
    @close="closeModal"
    hide-close-button
  >
    <loading :active="savingTemplate" :is-full-page="false" />

    <p v-if="selectedTemplate.shared" class="share-p">
      <StrongI18n
        keypath="modals.unshare_template"
        :values="{propName: selectedTemplate.name}"
      />
    </p>
    <p v-else class="share-p">
      <StrongI18n
        keypath="modals.share_template"
        :values="{propName: selectedTemplate.name}"
      />
    </p>

    <template #button>
      <button
        id="close-btn"
        class="btn btn-default right-margin"
        @click="close"
      >
        {{ $t('modals.close_button') }}
      </button>
      <button id="share-btn" class="btn btn-primary" @click="share">
        {{
          selectedTemplate.shared
            ? $t('modals.unshare_button')
            : $t('modals.share_button')
        }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import Loading from 'vue-loading-overlay';
import StrongI18n from '../lang/StrongI18n.vue';

export default {
  name: 'ShareTemplateModal',
  components: {
    SweetModal,
    Loading,
    StrongI18n
  },
  data() {
    return {
      selectedTemplate: {}
    };
  },
  computed: mapState({
    savingTemplate: state => state.savingTemplate,
    success: state => state.success
  }),
  methods: {
    ...mapActions(['doShareTemplate']),
    ...mapMutations(['setSuccess', 'templateShare']),
    open(template) {
      this.selectedTemplate = template;
      this.setSuccess(false);
      this.$refs.modal.open();
    },
    closeModal() {
      this.selectedTemplate = {};
    },
    share() {
      this.doShareTemplate(this.selectedTemplate);
    },
    close() {
      this.$refs.modal.close();
    }
  },
  watch: {
    success(newValue) {
      if (newValue === true) {
        this.$refs.modal.close();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
